export default function Popularity({ fill = "#004E99"}) {
  return (
    <>
      <svg
        width="12"
        height="14"
        viewBox="0 0 12 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.26358 13.827C0.430582 12.227 -0.315418 10.719 0.111582 8.655C0.426582 7.131 1.45758 5.891 1.55658 4.37C1.96178 5.0416 2.19341 5.80351 2.23058 6.587C3.72273 4.71059 4.55874 2.39682 4.61058 0C4.61058 0 8.25858 2.143 8.49758 5.381C8.86159 4.62735 8.91825 3.76167 8.65558 2.967C9.59758 3.654 15.1116 9.752 7.90858 13.827C8.52769 12.4898 8.66681 10.9801 8.30249 9.55232C7.93816 8.12454 7.09268 6.86604 5.90858 5.989C6.048 7.57724 5.63933 9.16534 4.75058 10.489C4.983 9.56745 4.88608 8.59366 4.47658 7.736C4.30491 8.51561 3.98512 9.255 3.53458 9.914C3.09125 10.4587 2.82746 11.1273 2.77947 11.828C2.73149 12.5286 2.90165 13.227 3.26658 13.827H3.26358Z"
          fill={fill}
        />
      </svg>
    </>
  );
}
